<div [formGroup]="formGroup">
  <h2 mat-dialog-title>{{ translations.title }}</h2>
  <mat-dialog-content>
    <app-input
      formControlName="internalReferenceNumber"
      [label]="translations.internalReferenceNumber"
    ></app-input>

    <app-input formControlName="referenceNumber" [label]="translations.referenceNumber"></app-input>
    <app-input
      formControlName="verificationNumber"
      [label]="translations.verificationNumber"
    ></app-input>
    <div class="font-size-14" i18n="@@delivery-overlay.addexistingreference.note">
      <b>Note:</b>
      the due diligence statement's status will be set to "Available", but this may not match the
      latest status on TRACES.
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <app-button-group>
      <app-button (pressed)="onClose()" type="ghost" i18n="@@shared.cancel">Cancel</app-button>
      <app-button (pressed)="onSubmit()" i18n="@@shared.confirm">Confirm</app-button>
    </app-button-group>
  </mat-dialog-actions>
</div>
